var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    fill: "#2E397E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9997 32.9163C22.5983 32.9163 22.2616 32.7803 21.9896 32.5083C21.7176 32.2363 21.5821 31.9001 21.583 31.4997V24.4163H14.4997C14.0983 24.4163 13.7616 24.2803 13.4896 24.0083C13.2176 23.7363 13.0821 23.4001 13.083 22.9997C13.083 22.5983 13.219 22.2616 13.491 21.9896C13.763 21.7176 14.0992 21.5821 14.4997 21.583H21.583V14.4997C21.583 14.0983 21.719 13.7616 21.991 13.4896C22.263 13.2176 22.5992 13.0821 22.9997 13.083C23.4011 13.083 23.7378 13.219 24.0098 13.491C24.2818 13.763 24.4173 14.0992 24.4163 14.4997V21.583H31.4997C31.9011 21.583 32.2378 21.719 32.5098 21.991C32.7818 22.263 32.9173 22.5992 32.9163 22.9997C32.9163 23.4011 32.7803 23.7378 32.5083 24.0098C32.2363 24.2818 31.9001 24.4173 31.4997 24.4163H24.4163V31.4997C24.4163 31.9011 24.2803 32.2378 24.0083 32.5098C23.7363 32.7818 23.4001 32.9173 22.9997 32.9163Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.2e433779c26906934a6c0ebdf046ace7.svg";
export { ForwardRef as ReactComponent };